export const AttributeForm = {
  model: 'Attribute',
  format: [
    {
      widths: 'equal',
      fields: {
        name: {
          required: true,
          type: 'text',
          label: 'Attribute Name',
        },
        description: {
          type: 'text area',
          label: 'Description',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        priority: {
          type: 'number',
          label: 'Display Order',
          helpText: 'Lower numbers appear first (1, 2, 3...)',
        },
      },
    },
  ],
}
